import { ReactNode } from "react";
import { cx } from "utils";
import { Align, alignClass } from "../types";

/** A body <td>. Base padding + text size; extend per cell via `className`. */
export const TableCell = ({
  children,
  align,
  className,
}: {
  children: ReactNode;
  align?: Align;
  className?: string;
}) => <td className={cx("px-6 py-3 text-sm", alignClass(align), className)}>{children}</td>;

export default TableCell;
